/*
 * Fixed mobile bottom navigation.
 *
 * The nav owns no behaviour: each item forwards its click to the control the
 * header already uses (search modal summary, menu drawer summary, wishlist app
 * icon, cart bubble), so those panels keep working exactly as they do today.
 *
 * The active indicator mirrors whatever that panel does — a <details> gaining
 * the `open` attribute, or the cart drawer gaining `.active` — rather than
 * tracking state here.
 */
(function () {
  function proxyTarget(link) {
    var selector = link.dataset.navProxy;
    return selector ? document.querySelector(selector) : null;
  }

  function bindClick(link) {
    link.addEventListener('click', function (event) {
      var target = proxyTarget(link);
      // No target (app block removed, JS-less control missing)? Let the
      // anchor's real href do its job instead.
      if (!target) return;

      event.preventDefault();

      // Panels that open on click register a click-away listener on <body>
      // (DetailsModal.open does exactly this for the search modal). This click
      // is still bubbling, so without stopping it here it would reach <body>
      // with the nav link as its target, read as "clicked outside the panel",
      // and shut the panel again in the same tap. The synthetic click below is
      // safe: its target sits inside the panel, so the click-away check passes.
      event.stopPropagation();

      target.click();
    });
  }

  function bindActiveState(link) {
    var selector = link.dataset.navActiveSource;
    if (!selector) return;

    var source = document.querySelector(selector);
    if (!source) return;

    var activeClass = link.dataset.navActiveClass;

    function sync() {
      var isActive = activeClass ? source.classList.contains(activeClass) : source.hasAttribute('open');
      link.classList.toggle('is-active', isActive);
    }

    new MutationObserver(sync).observe(source, {
      attributes: true,
      attributeFilter: activeClass ? ['class'] : ['open'],
    });

    sync();
  }

  function init() {
    document.querySelectorAll('.mobile-bottom-nav__link').forEach(function (link) {
      if (link.dataset.navProxy) bindClick(link);
      bindActiveState(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
